<template>
  <div class="bg-gradient-to-r from-purple-300 to-blue-200">
    <div class="w-9/12 m-auto py-16 min-h-screen flex items-center justify-center">
      <div class="bg-white shadow overflow-hidden sm:rounded-lg pb-8">
        <div class="border-t border-gray-200 pt-8">
          <base-spinner v-if="isLoading"></base-spinner>
          <div v-else-if="error">{{ error }}</div>
          <div v-else-if="hasRequests" class="flex flex-col px-10">
            <p class="text-2xl font-bold text-purple-400 px-5 text-center mb-5">Requests received</p>
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                    <tr>
                      <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Email
                      </th>
                      <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Message
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(request, requestIdx) in receivedRequests" :key="request.id" :class="requestIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                      <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        <a :href="emailLink"> {{ request.userEmail }}</a>
                      </td>
                      <td class="px-6 py-4 text-sm text-gray-500">
                        {{ request.message }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <h1 v-else class="text-4xl font-bold text-purple-400 px-5 text-center ">You haven't received any requests yet.</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Requests",
  props: ['email', 'message', 'coachId'],
  components: {
  },
  data() {
    return {
      isLoading: false,
      error: null,
    }
  },
  computed: {
    receivedRequests(){
      return this.$store.getters['requests/requests'];
    },
    hasRequests(){
      return this.$store.getters['requests/hasRequests'];
    },
    isLoggedInCoach(){
      return this.coachId === this.$store.getters.userId;
    },
    emailLink(){
      return 'mailto:' + this.email;
    },
  },
  created() {
    this.loadRequests();
  },
  methods:{
    async loadRequests(){
      //console.log('loadRequests');
      this.isLoading = true;
      this.error = null;
      try {
        await this.$store.dispatch('requests/fetchRequests');
      }
      catch(error){
        this.error = error.message || 'Failed to load list of messages';
      }
      this.isLoading = false;
    }
  },
}
</script>